module.exports = __webpack_public_path__ + "static/media/avatar7.399fa186.jpg";